import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import "../styles/Dashboard.css";
import Home from "../components/home";
import Devices from "../components/devices";
import Configs from "../components/config";
import DeviceDetails from "../components/device-details";
import Users from "../components/users";
import FleetHealth from "../components/fleetHealth";
import DeviceHealth from "../components/deviceHealth";
import Tickets from "../components/tickets";
import TicketDetail from "../components/ticketDetail";
import ConfigDetails from "../components/config-details";
import Shops from "../components/shops";
import ShopDetails from "../components/shop-details";
import Visits from "../components/visits";
import DiscoverCameras from "../components/discoverCameras";
import VisitDetail from "../components/visitDetail";
import ChecklistTemplates from "../components/checklistTemplates";
import Team from "../components/team";
import Releases from "../components/releases";
import MobileApp from "../components/mobileApp";
import Footfall from "../components/footfall";
import DoorAnalytics from "../components/doorAnalytics";
import FrameQuality from "../components/frameQuality";
import FrameQualityBench from "../components/frameQualityBench";
import ComplianceSelections from "../components/complianceSelections";
import SelectionMonitor from "../components/selectionMonitor";
import DetectionHealth from "../components/detectionHealth";
import ModelBench from "../components/modelBench";
import SkuLab from "../components/skuLab";
import PictureViewer from "./pictures";
import LogsViewer from "./logs";
import HeaderComponent from "../components/header";
import SiderComponent from "../components/sider";
import Settings from "../components/settings";
import Reports from "../components/reports";

const { Content } = Layout;

const Dashboard = ({ initialSelectedKey = "home" }) => {
  const [selectedKey, setSelectedKey] = useState(initialSelectedKey);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setSelectedKey(initialSelectedKey);
  }, [initialSelectedKey]);

  const renderContent = () => {
    switch (selectedKey) {
      case "home":
        return <Home />;
      case "devices":
        return <Devices />;
      case "discover":
        return <DiscoverCameras />;
      case "configurations":
        return <Configs />;
      case "releases":
        return <Releases />;
      case "mobile-app":
        return <MobileApp />;
      case "config-details":
        return <ConfigDetails />;
      case "outlets":
        return <Shops />;
      case "shop-details":
        return <ShopDetails />;
      case "visits":
        return <Visits />;
      case "visit-detail":
        return <VisitDetail />;
      case "checklist-templates":
        return <ChecklistTemplates />;
      case "team":
        return <Team />;
      case "device-details":
        return <DeviceDetails />;
      case "pictures":
        return <PictureViewer />;
      case "logs":
        return <LogsViewer />;
      case "users":
        return <Users />;
      case "footfall":
        return <Footfall />;
      case "door-analytics":
        return <DoorAnalytics />;
      case "frame-quality":
        return <FrameQuality />;
      case "compliance-selections":
        return <ComplianceSelections />;
      case "selection-monitor":
        return <SelectionMonitor />;
      case "detection-health":
        return <DetectionHealth />;
      case "threshold-bench":
        return <FrameQualityBench />;
      case "reports":
        return <Reports />;
      case "model-bench":
        return <ModelBench />;
      case "sku-lab":
        return <SkuLab />;
      case "health":
        return <FleetHealth />;
      case "device-health":
        return <DeviceHealth />;
      case "settings":
        return <Settings />;
      case "tickets":
        return <Tickets />;
      case "ticket-detail":
        return <TicketDetail />;
      default:
        return <h2>Select a section</h2>;
    }
  };

  return (
    <Layout className="dashboard-layout">
      <HeaderComponent />

      <Layout>
        <SiderComponent
          selectedKey={selectedKey}
          setSelectedKey={setSelectedKey}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        <Layout>
          <Content className="dashboard-content">{renderContent()}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
